/**
 * リザルト直後のひとこと(docs/07_learning_support.md §7.2)。
 *
 *   「まなび・タイピングのリザルトに小さな吹き出し(result。ログイン時のみ・失敗時は非表示)」
 *
 * ここが守ること:
 *   - **リザルト表示をブロックしない**。マウント後に非同期で聞きに行き、
 *     返ってきたら差し込む(点数・星は先に出ている)
 *   - **失敗したら何も出さない**。エラー文言も枠も出さない(静かに消える)
 *   - 1回のリザルトで**1回だけ**聞く(もういちど押せば新しい画面として1回)
 *
 * ローカルモードでは `supported: false` なので、そもそも聞きに行かない。
 */
import { useEffect, useState } from 'react';
import { appServices } from '../services/appServices';
import type { TutorContext, TutorReply } from '../services/tutor';

/**
 * @param context 送る補助文脈(**数値・enum のみ**)。`null` を渡すと聞きに行かない
 *                (リザルトがまだ無いときなど)。
 */
export function useTutorResult(context: TutorContext | null): TutorReply | null {
  const [reply, setReply] = useState<TutorReply | null>(null);

  // 依存は「送る中身」そのもの。数値と enum しか無いので JSON 化で比較できる
  // (オブジェクトを毎レンダー作り直しても、中身が同じなら聞き直さない)。
  const key = context === null ? null : JSON.stringify(context);

  useEffect(() => {
    if (key === null || !appServices.tutor.supported) return undefined;
    let alive = true;
    void appServices.tutor.ask('result', JSON.parse(key) as TutorContext).then((result) => {
      if (alive && result) setReply(result);
    });
    return () => {
      alive = false;
    };
  }, [key]);

  return reply;
}
